import React, {Component} from "react";
import {connect} from "react-redux";

import {setData} from "../../redux/actionCreators";
import './authorization_questions.css';
import CheckboxCustom from "../../components/checkbox_custom/CheckboxCustom";
import FooterContainer from "../../components/footer/FooterContainer";
import PageWithFooter from '../../components/page_with_footer/PageWithFooter';
import MainButton from "../../components/buttons/main_button/MainButton";
import TitleComponent from "../../components/title/TitleComponent";

class AuthorizationQuestions extends Component{
    constructor(props) {
        super(props);
        let data = props.stepInfo && props.stepInfo.answers ? props.stepInfo.answers : [];
        data = props.data && props.data.answers ? props.data.answers : data;
        this.state = {
            questions: props.stepInfo.question || [],
            answers: data.reduce((acc, ele) => {
                acc[ele.questionId] = ele.answerId;
                return acc;
            },{}),
        };

        this.renderQuestions = this.renderQuestions.bind(this);
        this.onChangeHandler = this.onChangeHandler.bind(this);
        this.isComplete = this.isComplete.bind(this);
        this.nextStepHandler = this.nextStepHandler.bind(this);
    }

    isAnswerResponded(questionId,answerId){
        return this.state.answers[questionId] === answerId;
    }

    convertToOutput(source){
        return Object.keys(source).map(questionId => ({questionId, answerId: source[questionId]}));
    }

    onChangeHandler(event){
        const value = event.currentTarget.getAttribute('value');
        const [questionAnswered, answerAnswered] = value.split('-');
        const answersNew = JSON.parse(JSON.stringify(this.state.answers));
        answersNew[questionAnswered] = answerAnswered;

        this.setState({
            answers: answersNew,
        })

        const data = this.convertToOutput(answersNew);
        this.props.setData({
            answers: data,
        });
    }

    isComplete(){
        try{
            return this.state.questions.length === this.props.data.answers.length;
        }catch (e){
            return false;
        }
    }

    nextStepHandler(event){
        this.props.setData({
            answers: this.convertToOutput(this.state.answers),
        });
        return this.props.nextStep(event);
    }

    renderQuestions(){
        return this.state.questions.map((question, index) => (
            <div className={'question'} key={`question-${question.questionId}`}>
                <div className={'question-title'}>{`${index+1}- `}{question.questionText}</div>
                <div className={'question-choices'}>
                    <ul>
                        {question.answerChoice.map(answerChoice =>
                           <li
                               key={`answer-${question.questionId}-${answerChoice.answerId}`}>
                               <CheckboxCustom
                                   name={`question-${question.questionId}`}
                                   value={`${question.questionId}-${answerChoice.answerId}`}
                                   checked={this.isAnswerResponded(question.questionId, answerChoice.answerId)}
                                   text={answerChoice.value}
                                   onChange={this.onChangeHandler}
                               />
                           </li>
                        )}
                    </ul>
                </div>
            </div>
        ));
    }

    render() {
        return (
            <div className={'authorization-question page-layout'}>
                <PageWithFooter
                    footer={(
                        <FooterContainer>
                            <MainButton
                                text={'Confirmar'}
                                onClick={this.nextStepHandler}
                                disabled={!this.isComplete()}
                            />
                        </FooterContainer>
                    )}
                >
                    <div className={'page-title'}>Responde las {this.state.questions.length} preguntas
                        para validar tu identidad</div>
                    {this.renderQuestions()}
                </PageWithFooter>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        stepInfo: state.stepInfo,
        data: state.data,
        stepData: state.stepData,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setData: (data) => {
            dispatch(setData(data));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthorizationQuestions);
